// IPFS上传工具函数

import { FileUploadResult } from '../types/kyc';
import axios from 'axios';
 
const APP_AUTH_BASEURL = process.env.REACT_APP_AUTH_BASEURL||'http://localhost:8000';
const ipfsgatewayurl = process.env.REACT_APP_IPFS_GATEWAY_BASEURL||"https://gateway.pinata.cloud";
const IPFS_API_ENDPOINT = process.env.REACT_APP_IPFS_API_ENDPOINT||"https://api.pinata.cloud";
 

 

export   async function getpinatakey(useraddress:any, maxuses: number,authjwk:string) { 
  try{  
   const endpoint =  APP_AUTH_BASEURL+'/getpinatakey';  
   const  result   = await axios.post(
     endpoint,
     JSON.stringify({"useraddress":useraddress}),
     { 
         headers: {
             'Content-type': `application/json` ,
             'Authorization': `Bearer ${authjwk}`,
             'useraddress': useraddress,
             'maxuses': maxuses
         }
     });   
    // console.log("getpinataapikey result   :",result); 
 
    if(result?.data?.JWT){ 
       //  console.log("getpinataapikey result?.data?.JWT  :",result?.data?.JWT);  
         return result?.data?.JWT; 
      }else{
         // toast.error("auth vip fail!");
          return ;
      } 
     
   } catch (error:any) {
    // console.log("getpinataapikey fail!"+ error);
    // toast.error("Sign in with polygon to the dapp fail!");
     return ;
   }
}

export const savemetaContentfromjwk = async (datajson: any,tempjwk?:string) => { 
  
  const endpoint = `${IPFS_API_ENDPOINT}/pinning/pinFileToIPFS`; 
  const st = JSON.stringify(datajson); 
  const blob = new Blob([st], { type: 'application/json' }); 
  const file = new File([ blob ], 'metaContent.json');  
  let data = new  FormData() as  any; 
  data.append('file', file); 
  const pinataOptions = JSON.stringify({
   cidVersion: 1,
 });
 data.append("pinataOptions", pinataOptions);
    const  result   = await axios.post(
      endpoint,
      data,
      { 
          headers: {
              'Content-type': `application/json`,
              Authorization: `Bearer ${tempjwk}`, 
          }
      });   
     console.log("Stored savemetaContent with result:", result);
 
     return ipfsgatewayurl+"/ipfs/"+result?.data?.IpfsHash;
 
 }
 
 export const saveblobContentfromjwk = async (file: File,tempjwk?:string) => {
    
      const start = Date.now();
       let data = new  FormData() as  any; 
         data.append('file', file); 
         const pinataOptions = JSON.stringify({
          cidVersion: 1,
        });
        data.append("pinataOptions", pinataOptions);
     const endpoint = `${IPFS_API_ENDPOINT}/pinning/pinFileToIPFS`; 
       const  result   = await axios.post(
         endpoint,
         data,
         {
           //  withCredentials: true,
           //  maxContentLength: 'Infinity' as any,
           //  maxBodyLength: 'Infinity' as any, //this is needed to prevent axios from erroring out with large directories
             headers: {
                 'Content-type': `multipart/form-data; boundary= ${data._boundary}`,
                 Authorization: `Bearer ${tempjwk}`,
                // 'pinata_api_key': process.env.REACT_APP_IPFS_API_KEY!,
                // 'pinata_secret_api_key': process.env.REACT_APP_IPFS_API_SECRET!
             }
         });   
       console.log("Stored savefileContent with result:", result);
       const ms = Date.now() - start;
       console.log("saveblobContentfromjwk upload ms:", ms);
 
        return ipfsgatewayurl+"/ipfs/"+result?.data?.IpfsHash;
 
 }



// 从IPFS获取数据
export const fetchFromIPFS = async (ipfsHash: string): Promise<any> => {
  try {
    const response = await fetch(ipfsUriToUrl(ipfsHash));
    if (!response.ok) {
      throw new Error('获取IPFS数据失败');
    }
    return await response.json();
  } catch (error: any) {
    console.error('从IPFS获取数据失败:', error);
    throw error;
  }
};

// 验证文件类型和大小
export const validateFile = (file: File, allowedTypes: string[], maxSize: number): string | null => {
  if (!allowedTypes.includes(file.type)) {
    return `不支持的文件类型。支持的类型: ${allowedTypes.join(', ')}`;
  }
  
  if (file.size > maxSize) {
    return `文件大小超过限制。最大允许: ${(maxSize / 1024 / 1024).toFixed(1)}MB`;
  }
  
  return null;
};

// 常用文件类型和大小限制
export const FILE_CONSTRAINTS = {
  IMAGE: {
    types: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    maxSize: 5 * 1024 * 1024 // 5MB
  },
  VIDEO: {
    types: ['video/mp4', 'video/webm', 'video/ogg'],
    maxSize: 50 * 1024 * 1024 // 50MB
  }
};
 


export const ipfsUriToUrl = (uri: string) => {
  const ipfsgatewayurl = 'https://gateway.pinata.cloud';
 
  if (uri === '' || uri === undefined || uri === null) {
    return '';
  }
  if (uri?.startsWith('https://ipfs.io')) {
    return uri.replace('https://ipfs.io', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://alchemy.mypinata.cloud')) {
    return uri.replace('https://alchemy.mypinata.cloud', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://cloudflare-ipfs.com')) {
    return uri.replace('https://cloudflare-ipfs.com', ipfsgatewayurl);
  }
  if (uri?.startsWith('https://4everland.io')) {
    return uri.replace('https://4everland.io', ipfsgatewayurl);
  }
  if (uri?.startsWith('ipfs://')) {
    return uri.replace('ipfs://', ipfsgatewayurl+'/ipfs/');
  }
  if (uri?.startsWith(ipfsgatewayurl)) {
    return uri ;
  }
  return  ipfsgatewayurl+'/ipfs/'+uri;
};